import { PropsWithChildren, ReactNode } from "react";
import { useMediaQuery } from "react-responsive";
import { Box } from "styled-system/jsx";

type ModalContentLayoutProps = PropsWithChildren & {
  imagesExist: boolean;
  header?: ReactNode;
};

export const ModalContentLayout = ({
  children,
  imagesExist,
  header,
}: ModalContentLayoutProps) => {
  // Panda responsive design syntax isn't working as expected for tablets
  const isDevice = useMediaQuery({ maxWidth: 1024 });
  return (
    <Box
      bg={"ink.100"}
      borderTopRadius={imagesExist ? "300" : undefined}
      zIndex={1}
      position={"relative"}
      overflow={"hidden"}
    >
      {header}
      <Box
        px={300}
        pt={600}
        pb={isDevice ? "130px" : 400}
        display={"flex"}
        flexDirection={"column"}
        gap={"600"}
      >
        {children}
      </Box>
    </Box>
  );
};
